import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=55a77af1&"
import script from "./Home.ts?vue&type=script&lang=ts&"
export * from "./Home.ts?vue&type=script&lang=ts&"
import style0 from "./Home.vue?vue&type=style&index=0&id=55a77af1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports